// extracted by mini-css-extract-plugin
module.exports = {"container":"tag-module--container--Gl-kf"};